import styled from '@emotion/styled';

export const Theme = {
  breakpoints: {
    largest: 1248,
    large: 1160,
    smartphone: 768,
    small: 708,
    smallest: 640,
  },
  mobileSpacing: 24,
  spacing: (spacing) => spacing * 4,
  flex: (flex) => (flex / 12) * 100,
};

export const Outer = styled.div({
  minHeight: '100vh',
  width: '100%',
  backgroundColor: '#FAFAFA'
})

export const Inner = styled.div({
  padding: '80px 24px',
  maxWidth: 880,
  margin: '0 auto',
})
